module.exports = __webpack_public_path__ + "img/logo_white.a2c33100.png";